/* unplugin-vue-components disabled */import script from "./HomeTopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTopMenu.vue?vue&type=script&setup=true&lang=js"

import "./HomeTopMenu.vue?vue&type=style&index=0&id=2279b709&lang=less"

const __exports__ = script;

export default __exports__